import { Injectable } from '@angular/core'
import { EditRentalTaxesDialogComponent } from './edit-rental-taxes-dialog.component'
import { Rental } from '@tokeet/tv3-platform'
import { take } from 'rxjs/operators'
import { MatDialog } from '@angular/material/dialog'

@Injectable()
export class EditRentalTaxesDialogService {
  constructor(private dialog: MatDialog) {}

  openEditRentalTaxes(rental: Rental) {
    const config = {
      width: '100%',
      height: '100%',
      maxWidth: 'auto',
      backdropClass: '',
      position: {
        right: '0px',
        bottom: '0px',
      },
      data: { rental },
      panelClass: ['overlay-20', 'modal', 'side-modal-lg', 'right'],
    }

    const dialogRef = this.dialog.open(EditRentalTaxesDialogComponent, config)

    if (dialogRef['_overlayRef'].overlayElement) {
      dialogRef['_overlayRef'].overlayElement.parentElement.className += ' dialog-wrapper'
    }

    dialogRef
      .beforeClosed()
      .pipe(take(1))
      .subscribe(() => {
        dialogRef['_containerInstance']['_elementRef'].nativeElement.classList.add('side-closing')
      })

    return dialogRef
  }
}
